export enum Breakpoint {
  WIDE = 1440,
}
